// extracted by mini-css-extract-plugin
export var compactFilters = "_cb-4";
export var detailImage = "_cb-1";
export var dropdownContainer = "_cb-2";
export var imageContainer = "_cb-0";
export var selectedCard = "_cb-3";